<template>
<section class="product-grid">

    <div class="cards">
    <!-- <div class="row"> -->
        <!-- <div v-for="p in products" :key="p.id" class="col-6 col-sm-6 col-md-4"> -->
            <ProductCard v-for="p in products" :key="p.id" :product="p" />
        <!-- </div> -->
    <!-- </div> -->
    </div>

    <section class="spacer-2x"></section>

    <nav class="text-center">
    <ul class="pages">
        <!-- first page -->
        <li :class="['page-item', {disabled: page==1}]">
            <router-link :to="{query: {'page': 1}}" class="page-link"><i class="far fa-angle-double-left fa-xs"></i></router-link>
        </li>
        <!-- prev page -->
        <li :class="['page-item', {disabled: page==1}]">
            <router-link :to="{query: {'page': page-1}}" class="page-link"><i class="far fa-angle-left fa-xs"></i></router-link>
        </li>
        <li
            v-for="p in range" :key=p
            :class="['page-item', {'active': p == page}]">
            <router-link :to="{query: {'page': p}}" class="page-link">{{ p }}</router-link>
        </li>
        <!-- next page -->
        <li :class="['page-item', {disabled: page==pages}]">
            <router-link :to="{query: {'page': page+1}}" class="page-link"><i class="far fa-angle-right fa-xs"></i></router-link>
        </li>
        <!-- last page -->
        <li :class="['page-item', {disabled: page==pages}]">
            <router-link :to="{query: {'page': pages}}" class="page-link"><i class="far fa-angle-double-right fa-xs"></i></router-link>
        </li>
    </ul>
    </nav>

</section>
</template>

<script>

    import ProductCard from "@/components/ProductCard.vue";
    import _ from 'lodash';

    export default {

        props: {
            products: Array,
            page: Number,
            pages: Number,
            maxPages: { default: 9 },
        },
        computed: {
            range: function() {
                // let width = 9
                let halfWidth = Math.ceil(this.maxPages / 2) // 5

                if (this.pages <= this.maxPages)
                    return _.range(1, this.pages+1)
                else if (this.page <= halfWidth)
                    return _.range(1, this.maxPages+1)
                else if (this.page > this.pages-halfWidth)
                    return _.range(this.pages-this.maxPages+1, this.pages+1)
                else
                    return _.range(this.page-halfWidth+1, this.page+halfWidth)
            }
        },
        methods: {

        },
        components: {
            ProductCard,
        },
    }
</script>

<style lang="scss" scoped>

    @import "@/scss/common.scss";
    @import "@/../node_modules/bootstrap/scss/_pagination.scss";

    .product-grid {

        .pages {
            @extend .pagination;
            justify-content: center;

            @media (max-width: map-get($grid-breakpoints, "sm" )) {
                @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $border-radius-sm);
            }
        }
    }

</style>
